export enum ReferralUserType {
  BORROWER_INDIVIDUAL = "BORROWER_INDIVIDUAL",
  BORROWER_LEGAL_ENTITY = "BORROWER_LEGAL_ENTITY",
  LENDER_INDIVIDUAL = "LENDER_INDIVIDUAL",
  LENDER_ENTREPRENEUR = "LENDER_ENTREPRENEUR",
  LENDER_LEGAL_ENTITY = "LENDER_LEGAL_ENTITY"
}
